import { useHistory } from 'react-router-dom'
import { useUserPermissions } from '@paintscout/ui-business'

export function useSherwinTrialOverDashboard() {
  const history = useHistory()
  const { permissionToUpdateBilling } = useUserPermissions()

  const handleSelectPlan = () => {
    history.push('/settings?section=billing-plan')
  }

  return {
    isAdmin: permissionToUpdateBilling,
    handleSelectPlan
  }
}
